// Date 2025-05-27 10:31:09

import emEpcTag from "@/store/em/epc/EmEpcTagStore.js";
import emEpcBindHis from "@/store/em/epc/EmEpcBindHisStore.js";
import emEpcTagMaterial from "@/store/em/epc/EmEpcTagMaterialStore.js";

const genericEntities = [
    'emEpcTag',
    'emEpcBindHis',
    'emEpcTagMaterial'
]

const entities = {
    emEpcTag,
    emEpcBindHis,
    emEpcTagMaterial
}

export {genericEntities}

export default entities
